import { useParams, useNavigate } from "react-router-dom";
import {  useEffect, useState } from "react";
import { retrieveTodoApi, updateTodoApi } from "./api/TodoApiService";
import { useAuth } from "./security/Authcontext";
import "./TodoUpdatePage.css";

function TodoUpdateComponent() {
  const { id } = useParams();
  const navigate = useNavigate();
  const authContext = useAuth();
  const username = authContext.usrname;

  const [description, setDescription] = useState("");
  const [targetDate, setTargetDate] = useState("");
  const [isDone, setIsDone] = useState(false);

  useEffect(() => {
    retrieveTodoApi(username, id)
      .then((response) => {
        setDescription(response.data.description);
        setTargetDate(response.data.targetDate);
        setIsDone(response.data.done);
      })
      .catch((error) => console.error(error));
  }, [id, username]);

  function handleSubmit(e) {
    e.preventDefault();

    const updatedTodo = {
      id: Number(id),
      userName: username,
      description,
      targetDate,
      done: isDone,
    };

    updateTodoApi(username, id, updatedTodo)
      .then(() => navigate("/list-todos"))
      .catch((error) => console.error("Update failed", error));
  }
  function handleToggleChange(e) {
    setIsDone(e.target.checked); // ✅ FIXED
  }


  return (
    <div className="todo-update-page">
    <div className="todo-update-container">
      <h1>Update Todo</h1>
      <p className="subtitle">
        Modify your task details and save changes
      </p>

      <form className="todo-update-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Description</label>
          <input
            type="text"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Target Date</label>
          <input
            type="date"
            value={targetDate}
            onChange={(e) => setTargetDate(e.target.value)}
          />
        </div>

        <div className="checkbox-group">
          <input
            type="checkbox"
            checked={!!isDone}
            onChange={handleToggleChange}
          />
          <label>Mark as completed</label>
        </div>

        <div className="form-actions">
          <button
            type="button"
            className="cancel-btn"
            onClick={() => navigate("/list-todos")}
          >
            Cancel
          </button>

          <button type="submit" className="update-button">
            Update Todo
          </button>
        </div>
      </form>
    </div>
  </div>
  );
}

export default TodoUpdateComponent;
